<template>
  <div>
    <div class="container ">
      <div class="img">
        <!-- <img src="@/assets/images/pages/forgot_password.svg"> -->
      </div>
      <div class="forgetpass-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Reset Password</h3>
          <div class="input-div mt-2">
            <div>
               <vs-input
                ref="password"
                v-validate="'required|min:6|max:255'"
                data-vv-validate-on="blur"
                size="large"
                type="password"
                name="password"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border
                v-model="password"
                label-placeholder="PASSWORD"
                class="w-full mt-6"/>
            <span class="text-danger text-sm float-left">{{ errors.first('password') }}</span>
            </div>
          </div>

          <div class="input-div mt-2">
            <div>
               <vs-input
                type="password"
                v-validate="'min:6|max:255|confirmed:password'"
                data-vv-validate-on="blur"
                data-vv-as="password"
                name="confirm_password"
                size="large"
                label-placeholder="CONFIRM PASSWORD"
                v-model="confirm_password"
                class="w-full mt-8"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border />
                <span class="text-danger text-sm float-left">{{ errors.first('confirm_password') }}</span>
            </div>
          </div>
            <vs-button class="shadow-md w-full mt-8" @click="resetPassword(password)" :disabled="!validateForm">Reset Password</vs-button>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'
import axios from '@/axios'
import router from '@/router'


const dialogs = {
  expired: (error) => {
    return {
      color: "danger", 
      title: "Session Expired.",
      text: "Session exipired, kindly reset password again.",
      accept:() => {
        router.push('/forgot-password')
      },
      close:() => {
        router.push('/forgot-password')
      }
    }
  }
}

export default {
  components: {
    Logo
  },
  data () {
    return {
      password: '',
      confirm_password: ''
    }
  },
  beforeMount(){
    console.log(this.token)
    const headers = { 'Content-Type' : 'application/json' }
      axios.post('/auth/token_validity', { token: this.token }, {
        headers
      }).then((res) => {
        if(res.data.data !== 'valid'){
          this.$vs.dialog(dialogs.expired())
        } else {
          console.log('success')
        }
      }).catch((err) => { console.log(err) })
    
  },
  computed: {
    validateForm (){
      return !this.errors.any() && this.password !== '' && this.confirm_password !== ''
    },
    token(){
      return decodeURIComponent(this.$route.path.replace('/reset/',''))
    }
  },
  methods: {
    resetPassword(password){
      const headers = { 'Content-Type' : 'application/json' }
        axios.patch('/auth/reset_password', { token : this.token, password }, {
        headers
      }).then(() => { 
        this.$vs.notify({
          title: 'Reset Successful!',
          text: 'Now you can login to your account.',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
        router.push('/login')
      }).catch((error) => {
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  }
}
</script>

<style scoped>
* {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}

body {
  display:flex;
}

.container {
    width: 50vw;
    height: 50vw;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-gap: 28rem;
    padding: 0 2rem;
    
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center
}
/*
.img img{
   width: 600px; 
} */

.forgetpass-container {
    display: flex;
    place-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 80px;
    margin-bottom: 30px;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #F9278E;
}


.input-div > div {
    position: relative;
    height: 45px;

}

.input-div > div h5{
    position:absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #f9278e;
    display: none;
    font-size: 18px;
    transition: .3s;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 6rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    /* .img img{
        width: 400px;
    } */
}

@media screen and (max-width: 900px) {
    /* .img{
        display:none;
    } */
    .container{
        grid-template-columns: 1fr;
    }
    .forgetpass-container{
        justify-content: center;
    }
}
</style>
